._container_1i0o9_1 {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column; }
